import statusReducer from '@sophocles/features/status/slice';

export default statusReducer;
